export default {
    // A
    addToCalendar: 'Add to calendar',
    allTypes: 'All types',
    anyCreator: 'Anyone',

    // C
    channelRooms: 'Channel rooms',
    clearFilters: 'Clear',
    clearSearch: 'Clear search',
    createdBy: 'Created by',
    copyFailed: 'Could not copy the link.',
    copyLink: 'Copy link',

    // F
    filterByCreator: 'Filter by who created the room',
    filterByType: 'Filter by recording type',
    filterResults: '{n} of {total} rooms match the current filters.',

    // L
    linkCopied: 'Link copied',
    length: 'Length',

    // N
    next: 'Next',
    nextPage: 'Next page',
    noUpcomingRooms: 'No rooms yet. Pick an option above to record something.',
    noPastRooms: 'No past recordings.',
    noMatchingRooms: 'No rooms match “{query}”.',
    noMatchingRoomsOtherTab: 'No rooms match “{query}” here. Check the {tab} tab.',
    noMatchingFilters: 'No rooms match these filters.',
    noMatchingFiltersOtherTab: 'No rooms match these filters here. Check the {tab} tab.',
    notSet: 'Not set',

    // M
    myRecordings: 'My recordings',

    // O
    open: 'Open',

    // P
    participants: '{n} participant | {n} participants',
    pagination: 'Room list pagination',
    previous: 'Previous',
    previousPage: 'Previous page',
    pageOf: 'Page {page} of {total}',

    // R
    ready: 'Recording ready',
    recording: 'Recording',

    // S
    submitVideo: 'Submit video',
    searchPlaceholder: 'Search rooms…',
    searchRooms: 'Search rooms by name, person, or kind',
    showingRange: '{from}–{to} of {total}',
    status: 'Status',

    // U
    unknown: 'Unknown',

    // V
    view: 'View recording',

    // W
    when: 'When',
    who: 'Who',
}
